<template src="./Alerts.html">
  
</template>

<script>

import { mapState } from "vuex";

import Alert from '@/components/Alert/Alert';

export default {
    name: 'Alerts',
    components: {
        Alert,
    },
    data() {
        return {
        }
    },
    computed: {

        ...mapState({
            alerts: state => state.alerts
        }),
        
    }
}
</script>

<style src="./Alerts.scss" lang="scss">

</style>